export default function Hero() {
  return (
    <section className="hero" id="top">
      <div className="container">
        <p className="hero-eyebrow">Built for K-12 private schools</p>
        <h1>
          Tuition, fees, and enrollment{" "}
          <span className="accent">in one place</span>.
        </h1>
        <p className="lede">
          Easy School Payments replaces the spreadsheets, paper checks, and
          disconnected tools your school uses today. Parents pay online, your
          office tracks it all in real time.
        </p>
        <div className="hero-actions">
          <a href="#contact" className="btn btn-primary btn-large">
            Request a demo
          </a>
          <a href="#features" className="btn btn-large">
            See what's included
          </a>
        </div>
      </div>
    </section>
  );
}
